<template>
  <v-app id="beerapp">
    <v-navigation-drawer v-model="drawer" v-if="$store.state.loggedIn" app>
      <v-list dense>

        <v-list-item>
          <v-list-item-avatar>
            <v-img :src="$store.state.avatar"></v-img>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{$store.state.nickname}}</v-list-item-title>
            <v-list-item-subtitle>{{$store.state.email}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item to="/" router exact>
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/test" router exact>
          <v-list-item-action>
            <v-icon>mdi-test</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Test</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      <v-list-group no-action  value="true" prepend-icon="mdi-postage-stamp">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Collections</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-for="(item, i) in $store.state.collections" :key="i"  :to="{name: item.to, params: { collectionId: item.Id}}" router>
            <v-list-item-title v-text="item.name"></v-list-item-title>
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
          </v-list-item>

        </v-list-group>

        <v-list-item link v-on:click="onLogout">
          <v-list-item-action>
            <v-icon>mdi-power</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="primary" dark dense>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="$store.state.loggedIn" />

      <v-btn icon @click="onBack" v-if="backVisible">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title>BeerPlanet.net - {{$route.meta.title}}</v-toolbar-title>
    </v-app-bar>

    <v-main>
      <v-container>
        <keep-alive :max="10">
          <router-view :key="$route.fullPath"></router-view>
        </keep-alive>
      </v-container>
    </v-main>

    <v-footer color="primary" app dense>
      <span class="white--text">&copy; beerplanet.net 2020</span>
    </v-footer>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  data: () => ({
    drawer: null,
    // collectionItems: [
    //   {
    //     icon: 'mdi-glass-mug-variant',
    //     title: 'Tasted',
    //     to: 'Collection',
    //     Name: 'Tasted',
    //     Id: 2,
    //   },
    //   {
    //     icon: 'mdi-package-variant',
    //     title: 'Stock',
    //     to: 'Collection',
    //     Name: 'Stock',
    //     Id: 1,
    //   },
    //   {
    //     icon: 'mdi-cart-arrow-down',
    //     title: 'Shopping',
    //     to: 'Collection',
    //     Name: 'Shopping',
    //     Id: 3,
    //   },
    //   {
    //     icon: 'mdi-bookmark-check',
    //     title: 'Bookmarked',
    //     to: 'Collection',
    //     Name: 'Bookmarked',
    //     Id: 4,
    //   },
    // ],
  }),
  components: {
  },
  methods: {
    onLogout() {
      this.$store.state.token = false;
      this.$store.state.username = 'Logged Out';
      this.$store.state.email = '';
      this.$store.state.loggedIn = false;
      this.$webConn.token = false;
      this.$storage.write('token', false);
      this.$router.push('/login');
    },
    onBack() {
      // this.$router.go(-1);
      this.$router.back();
    },
  },
  computed: {
    backVisible() {
      if (this.$route.name !== 'Home' && this.$route.name !== 'Login') {
        return true;
      }

      return false;
    },
  },
  created() {
    // console.log(this.$route.name);
    if (this.$store.state.token) { // we have a token, lets try a token login first
      this.$webConn.setToken(this.$store.state.token);

      this.$webConn.request('app2_token_login', {}).then((result) => {
        this.$root.afterLogin(result);
      }).catch((error) => {
        console.log('Token Login error');
        this.$router.push('/login').catch((e) => {});
      });
    } else {
      console.log('No Token');
      this.$router.push('/login').catch((e) => {});
    }
  },
  watch: {
  },
};
</script>
